/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CountByMediaType,
    CountByMediaTypeFromJSON,
    CountByMediaTypeFromJSONTyped,
    CountByMediaTypeToJSON,
} from './CountByMediaType';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';
import {
    PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponseAllOf,
    PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponseAllOfFromJSON,
    PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponseAllOfFromJSONTyped,
    PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponseAllOfToJSON,
} from './PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponseAllOf';

/**
 * response of POST /prtimes_media_lists/media_outlets/search_count_by_media_type
 * @export
 * @interface PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponse
 */
export interface PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponse
     */
    message: string;
    /**
     * 
     * @type {Array<CountByMediaType>}
     * @memberof PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponse
     */
    searchCountByMediaType: Array<CountByMediaType>;
}

export function PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponseFromJSON(json: any): PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponse {
    return PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponseFromJSONTyped(json, false);
}

export function PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'searchCountByMediaType': ((json['search_count_by_media_type'] as Array<any>).map(CountByMediaTypeFromJSON)),
    };
}

export function PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponseToJSON(value?: PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'search_count_by_media_type': ((value.searchCountByMediaType as Array<any>).map(CountByMediaTypeToJSON)),
    };
}

